import { createContext } from '@chakra-ui/react-utils';
import { SystemStyleObject } from '@chakra-ui/system';

import type { AlertProps } from '../Alert';

export type AlertContextValue = {
  status: NonNullable<AlertProps['status']>;
};

export const [AlertProvider, useAlertContext] =
  createContext<AlertContextValue>({
    name: 'AlertContext',
    strict: true,
    errorMessage:
      'useAlertContext: `context` is undefined. Seems you used an Alert sub-component outside of an Alert wrapping box.',
  });

export const [AlertStylesProvider, useAlertStyles] = createContext<
  Record<string, SystemStyleObject>
>({
  name: `AlertStylesContext`,
  strict: true,
  errorMessage:
    'useAlertStyles: `context` is undefined. Seems you used an Alert sub-component outside of an Alert wrapping box.',
});
